import { useOrganization } from "@/hooks/useOrganization";
import { useUiUpliftSettled } from "@/hooks/useUiUplift";

/**
 * Whether Settings (`/settings/:section`) knows which variant to draw (#6736). Usually that is once
 * the organization's ui_uplift flag has been read. A viewer with no organization, such as a platform
 * admin who belongs to none, has no organization flag: FeatureFlagProvider never reads one for them,
 * so the variant useUiUplift() gives them now is final, and Settings must not wait for a read that
 * never starts. "No organization" counts only once the organization has finished resolving.
 */
export function useSettingsVariantSettled(): boolean {
  const flagSettled = useUiUpliftSettled();
  const { organizationId, isLoading, isResolving } = useOrganization();
  return flagSettled || (!organizationId && !isLoading && !isResolving);
}
